/**
 * Created by Ram on 17/03/2017.
 */

import React from "react";
import RegisteredDevicesList from './DeviceManagement/RegisteredDevicesList'
import UnregisteredDevicesList from './DeviceManagement/UnregisteredDevicesList'

const DeviceManagement = (props) => {
  const { 
    deleteDevice, 
    updateSortState, 
    updateSortNewState,
    updateSearchState,
    updateSearchNewState,
    navigator
  } = props

  const { 
    sort, 
    sortAsc, 
    sortNew, 
    sortNewAsc, 
    devicesNew, 
    devicesRegistered,
    search,
    searchNew
  } = props.loadData

  return (
    <div>
      <ol className="breadcrumb">
        <li className="active">Device Management</li>
      </ol>

      <div className="device-management-main-div pull-left">
        <div className="search-device-list">
          <div className="row">
            <div className="col-sm-4">
              <span className="block-heading">
                <span className="glyphicon glyphicon-phone" /> 
                Registered Devices ({devicesRegistered.length})
              </span>
            </div>
            <div className="col-sm-3 shift-left">
              <button
                type="button"
                className="btn btn-add pull-right"
                onClick={navigator.requestAddNewDevice}
              >
                <span className="glyphicon glyphicon-plus addIcon" /> New
              </button>
            </div>
            <div className="col-sm-1">
              <button
                type="button"
                className="btn btn-info pull-right"
                onClick={navigator.requestClusterManagement}
              >
                <span className="glyphicon glyphicon-th" /> Clusters
              </button>
            </div>
            <div className="col-sm-4">
              <input
                type="search"
                placeholder="Search..."
                className="form-control pull-left"
                onChange={updateSearchState}
                value={search}
              />
            </div>
          </div>
        </div>

        <div className="table registered-devices-list">
          <div id="registered-device-list-main-table">
            <RegisteredDevicesList
                devices={devicesRegistered}
                onEdit={navigator.requestEditDevice}
                onDelete={deleteDevice}
                onSort={updateSortState}
                sortBy={sort}
                isSortAsc={sortAsc} 
              />
          </div>
        </div>
      </div>

      <div className="device-management-second-div pull-right">
        <div className="search-device-list">
          <div className="row">
            <div className="col-sm-7">
              <span className="block-heading">
                <span className="glyphicon glyphicon-phone" /> 
                Unregistered Devices ({devicesNew.length})
              </span>
            </div>
            <div className="col-sm-5">
              <input
                type="search"
                placeholder="Search..."
                className="form-control pull-left"
                onChange={updateSearchNewState}
                value={searchNew}
              />
            </div>
          </div>
        </div>

        <div className="table new-devices-list">
          <div id="registered-device-list-main-table">
            <UnregisteredDevicesList 
              devices={devicesNew}
              onEdit={navigator.requestEditDevice}
              onDelete={deleteDevice}
              onSort={updateSortNewState}
              sortBy={sortNew}
              isSortAsc={sortNewAsc} 
            />
          </div>
        </div>
      </div>
    </div>
  ); // return
}

export default DeviceManagement;
